import { FOCUS_RING } from '@amelio/ui-library';

import type { ReactNode } from 'react';

import AppLink from '@/components/AppLink/AppLink';

interface TileLinkProps {
    /** The path the tile leads to; also the `href`, so the link opens in a new tab like any other. */
    to: string;
    /** The location state the tile's own click carries, so the keyboard lands the same way. */
    state?: unknown;
    children: ReactNode;
    className?: string;
    /** Replaces the visible text as the link's name, when that text alone would say too little. */
    ariaLabel?: string;
    dataTestId?: string;
}

/**
 * The real link of a clickable tile, set on its title. The tile around it stays clickable with the
 * mouse, but only this link is announced and reached with the keyboard, so the tile never becomes
 * a link wrapping the other buttons it holds (a menu, a toggle).
 */
export default function TileLink({
    to,
    state,
    children,
    className,
    ariaLabel,
    dataTestId,
}: TileLinkProps) {
    return (
        <AppLink
            to={to}
            state={state}
            // The tile around the link runs the same navigation on a click anywhere else.
            onClick={(event) => event.stopPropagation()}
            className={`${FOCUS_RING} cursor-pointer text-left${className ? ` ${className}` : ''}`}
            ariaLabel={ariaLabel}
            dataTestId={dataTestId}
        >
            {children}
        </AppLink>
    );
}
